import { responsiveGridSizeTimes } from '@townsquare/responsive-grid/responsive-grid';

export const OnlyMainColumnMaxWidth = responsiveGridSizeTimes(11);
